import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import firebase from "firebase/app";
import firebaseConfig from "./firebase/config.js";

import LoadingSpinner from "./components/UI/LoadingSpinner.vue";
import TheHeader from "./components/UI/TheHeader.vue";

import PrimeVue from "primevue/config";
import Menu from "primevue/menu";
import Button from "primevue/button";
import Checkbox from "primevue/checkbox";
import SelectButton from "primevue/selectbutton";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import InputMask from "primevue/inputmask";
import Textarea from "primevue/textarea";
import Skeleton from "primevue/skeleton";
import Dialog from "primevue/dialog";

import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

firebase.initializeApp(firebaseConfig);

const app = createApp(App);

app.use(store);
app.use(router);
app.use(PrimeVue, { ripple: true });

app.component("LoadingSpinner", LoadingSpinner);
app.component("TheHeader", TheHeader);

app.component("Menu", Menu);
app.component("Button", Button);
app.component("Checkbox", Checkbox);
app.component("SelectButton", SelectButton);
app.component("InputText", InputText);
app.component("InputNumber", InputNumber);
app.component("InputMask", InputMask);
app.component("Textarea", Textarea);
app.component("Skeleton", Skeleton);
app.component("Dialog", Dialog);

app.mount("#app");
